import './index.scss';
import React, { useState } from 'react';
import { Carousel } from 'antd-mobile';
import banner1 from '../../images/banner_01.png';

function Banner() {
  const [bannerList] = useState([
    { url: banner1, key: 'banner-001' },
  ]);

  return (
    <div className="banner">
      <Carousel autoplay infinite>
        {bannerList.map((item, index) => (
          <div
            className="item"
            key={`${item.key}${index}`}
            style={{ backgroundImage: `url(${item.url})` }}
          />
        ))}
      </Carousel>
    </div>
  );
}

export default Banner;
